import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { apiErrorMessage } from "@/lib/api";
import { ChefHat, Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(name, organizationName, email, password);
      toast.success("Conta criada com sucesso");
      navigate("/");
    } catch (err) {
      toast.error(apiErrorMessage(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="register-page">
      <div className="w-full max-w-md bg-white rounded-lg border border-slate-200 p-6 shadow-sm">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-md bg-emerald-800 flex items-center justify-center text-white"><ChefHat size={20} /></div>
          <div className="text-xl font-semibold">MenuPro</div>
        </div>
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Criar organização</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">Você será o administrador da conta. Depois poderá adicionar outros usuários da sua empresa.</p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-wide text-slate-600">Nome da sua empresa / organização</Label>
            <Input required value={organizationName} onChange={(e) => setOrganizationName(e.target.value)} placeholder="Ex.: Nutri Refeições Ltda." data-testid="register-org-input" className="mt-1" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wide text-slate-600">Seu nome</Label>
            <Input required value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name-input" className="mt-1" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wide text-slate-600">Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email-input" className="mt-1" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wide text-slate-600">Senha</Label>
            <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password-input" className="mt-1" />
          </div>
          <Button type="submit" disabled={busy} data-testid="register-submit-btn" className="w-full bg-emerald-900 hover:bg-emerald-800 text-white">
            {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null} Criar organização
          </Button>
        </form>
        <div className="text-sm text-slate-500 mt-5">
          Já tem conta?{" "}
          <Link to="/login" className="text-emerald-800 font-medium hover:underline" data-testid="go-login-link">Entrar</Link>
        </div>
      </div>
    </div>
  );
}
